import { render, staticRenderFns } from "./LossReasons.vue?vue&type=template&id=829d524c&scoped=true"
import script from "./LossReasons.vue?vue&type=script&lang=js"
export * from "./LossReasons.vue?vue&type=script&lang=js"
import style0 from "./LossReasons.vue?vue&type=style&index=0&id=829d524c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829d524c",
  null
  
)

export default component.exports